<template>
  <div class="resetPasswordForm">
    <div v-if="!loading && canSet && !resetFailed && !resetSuccess">
      <h2>Reset Password</h2>
      <el-alert
        class="errorMessage"
        :title="error"
        type="error"
        v-show="error"
        :closable="false">
      </el-alert>
      <el-input placeholder="Enter new password" @keyup.enter.native="submit"
                v-model="password" class="password" type="password"></el-input>
      <el-input placeholder="Confirm new password" @keyup.enter.native="submit"
                v-model="passwordConfirm" class="password" type="password"></el-input>
      <el-button type="primary" class="loginButton" @click="submit">Reset Password</el-button>
    </div>
    <div v-else-if="(!loading && !canSet) || resetFailed">
      <p align="center">That link has expired.</p>
    </div>
    <div v-else-if="!loading && resetSuccess">
      <p align="center">Password successfully reset. <router-link :to="{ name: 'login' }">Log In</router-link></p>
    </div>
  </div>
</template>

<script>
  import ApiClient from '@/components/api-client'
  export default {
    name: 'perform-password-reset',
    props: ['loading', 'canSet', 'token'],
    data () {
      return {
        password: null,
        passwordConfirm: null,
        error: '',
        resetSuccess: false,
        resetFailed: false
      }
    },
    methods: {
      submit (e) {
        e.preventDefault()

        if (this.password !== this.passwordConfirm) {
          this.error = 'Passwords don\'t match'
        }

        if (this.password === '' || this.passwordConfirm === '') {
          this.error = 'Please enter a password'
        }

        if (this.error !== '') {
          return
        }

        const body = {
          password: this.password,
          passwordConfirm: this.passwordConfirm,
          et: this.token
        }

        ApiClient.submitPasswordReset(body)
          .then(() => {
            this.resetSuccess = true
          })
          .catch((e) => {
            if ('nonFieldErrors' in e.response.data) {
              this.error = e.response.data.nonFieldErrors[0]
            }

            if (e.response.status === 404) {
              this.resetFailed = true
            }
          })
      }
    },
    watch: {
      password (newVal, oldVal) {
        if (oldVal !== '') {
          this.error = ''
        }
      }
    }
  }
</script>

<style scoped lang="scss">

  .resetPasswordForm {
    box-sizing: border-box;
    width: 420px;
    padding: 25px 30px 25px 30px;
    border-radius: 5px;
    background-color: #ffffff;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.14);
    h2 {
      font-weight: normal;
      color: #898989;
      margin: 0;
    }
    p {
      margin: 0;
    }
    button {
      float: right;
    }
    .password {
      margin: 15px 0;
      &:last-of-type {
        margin-top: 0;
      }
    }

  }
</style>
